import { useRole } from '@/hooks/useRole'
import { ClerkUserRole } from '@/types/auth'

/**
 * Where *Admin Portal* lands for every role that is offered it (ENG-3568).
 *
 * Held next to the predicate because the two menus that read `useHasAdminPortalAccess`
 * also have to agree on the destination.
 */
export const ADMIN_PORTAL_PATH = '/admin'

/**
 * Does the signed-in viewer have an admin portal to go to? (ENG-3568)
 *
 * **The one place that question is answered**, because it is now asked from two
 * shells that cannot see each other. `Header` reads it to decide whether to offer
 * *Admin Portal* in the user menu; `CoachIdentity` reads it to offer the way back
 * *out* of the coach portal, which has no header of its own.
 *
 * **Not learners, and not coaches.** A coach is not an EnGen admin who coaches —
 * they have deliberately narrower access and no administration to enter (recorded
 * on the ADR, ENG-3440). The entry a coach used to get pointed at
 * `/admin/my-availability`, which was the coach portal wearing the wrong label.
 *
 * Not an authorization check: `ROUTE_ACCESS_CONFIG` decides who may open the
 * admin routes. This only decides who is offered the door. Where that door goes
 * is `ADMIN_PORTAL_PATH`, read by the same two call sites.
 */
export function useHasAdminPortalAccess(): boolean {
  const { userRole, isLoaded } = useRole()

  return isLoaded && userRole !== undefined && userRole !== ClerkUserRole.LEARNER && userRole !== ClerkUserRole.COACH
}
